import { ITypedModel } from 'core-ts-types';
import { Model } from 'utility-ts-orm';

export interface IPronounsData {
  formatted_pronouns: string;
  selected_pronouns: string;
  user_id: string;
}

export type PronounsModel = ITypedModel<IPronounsData>;

angular.module('capability-ng-priority-feed').factory(
  'ngPronounsModel',
  () =>
    new Model<IPronounsData>({
      formatted_pronouns: '',
      selected_pronouns: '',
      user_id: ''
    })
);



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-priority-feed/src/models/pronouns_model.ts